module.exports = __webpack_public_path__ + "static/media/92.97842b3e.png";